// extracted by mini-css-extract-plugin
module.exports = {"dailyMeme":"styles_dailyMeme__28bR3"};